module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"seconds":"sek","play":"spill nå","locked":"låst"},"en":{"seconds":"sec","play":"play now","locked":"locked"}}')
  delete Component.options._Ctor
}
